<template>
    <div >
        <v-row class="mb-3 py-2" no-gutters>
            <v-col cols="10" sm="6" class="d-flex justify-start mb-2">
                <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
            </v-col>
        </v-row>
        <div class="contenedor-tabla">
            <div class="scroll-container">
                <table>
                   <!--  <caption class="table-header">Senda de {{ this.$t('tabs.demanda_frio') }}</caption> -->
                    <thead>
                    <tr>
                        <th class="encabezado_bold" >{{ this.$t('demanda.horizonte') }}</th>
                        <th class="encabezado_bold" >{{ this.$t('demanda.hora') }}</th>
                        <th class="encabezado_bold" >{{ this.$t('demanda.frio') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="( row,index) in demandaFrio.slice(0,this.horizonte_horas)" :key="index" class="tabla-hover">
                        <td class="primera_columna">{{row.horizonte }}</td>
                        <td class="primera_columna" style="text-align: center !important;">{{ row.hora}}</td>
                        <td >
                            <input
                            
                        type="number"
                        v-model.number="row.valor"
                        @input="emitChanges()"
                        
                    />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="showAlert" max-width="400">
                <v-card>
                    <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
                    <v-card-text>
                    {{ error_msg }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
    </div>

           

</template>


<script>
import Papa from 'papaparse';
import Swal from 'sweetalert2';

const HEADERS_OFICIALES_FRIO = [
  "Horizonte",
  "Hora",
  "Demanda de frío (MW)"
];
//imports
export default{
   props:{
    horizonte_horas:{
        type:Number,
        required:true,
    },
    demanda_frio:{
        type:Array,
        required:true,
    },
    horizonte:{
        type:Number,
        required:true,
    }

   },
   
   components:{
      

   },
   data(){
       return{

            showAlert:false,
            error_msg:"",
            matrixData : [
                   
               ],
           hoursList:[],
           demandaFrio : 
                    [...this.demanda_frio]
                   ,
                   coef:this.demanda_coef,
               columns:[
               { name: "Horizonte", prop: "horizonte", size: 150, readonly:true },
               {name: this.$t("demanda.frio"), prop:"demanda_frio",size:200},
               
                   ],
       }
   },
   created(){
       this.crearColumnas(7);
   },
   watch:{

    demanda_frio: {
        handler(nuevaDemanda) {
            console.log("Demanda de frío actualizada en el hijo:", nuevaDemanda);
            this.demandaFrio = [...nuevaDemanda]; // Forzar actualización
        },
        deep: true
    }
   
},
   methods:{
     // ==== Export con coma decimal ====
    toCsvDecimalComma(v, fixed = 2) {
      if (v === null || v === undefined || v === "") return "";
      let n = Number(v);
      if (Number.isNaN(n)) n = Number(String(v).replace(",", "."));
      if (Number.isNaN(n)) return "";
      return n.toLocaleString("es-ES", {
        minimumFractionDigits: fixed,
        maximumFractionDigits: fixed,
        useGrouping: false,
      });
    },
    emitChanges(){
        this.$emit("update:demanda_frio", this.demandaFrio);  
    },
    exportToCSV() {
      const headers = "Horizonte;Hora;Demanda de frío (MW)";
      const rows = this.demandaFrio
        .slice(0, this.horizonte_horas)
        .map((row) => {
          const horizonte = row.horizonte ?? "";
          const hora = row.hora ?? "";
          const valor = this.toCsvDecimalComma(row.valor, 2);
          return [horizonte, hora, valor].join(";");
        });

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob(["\uFEFF" + csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "demanda_frio.csv";
      a.click();
      URL.revokeObjectURL(url);
    },
       crearColumnas(dias){
            const currentDate = new Date();

            // Sumar un día a la fecha actual
            currentDate.setDate(currentDate.getDate() + 1);
            
            // Generar la columna con las horas
             this.hoursList = [];
            for (let day=0; day<dias;day++){
                const newDate = new Date(currentDate);
                newDate.setDate(currentDate.getDate() + day);
                const formattedDate = newDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Formato 28-01-25
        
                for (let i = 0; i < 24; i++) {
                    const hour = i.toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
                    this.hoursList.push(`${formattedDate} ${hour}:00`);
                    this.matrixData.push({
                        horizonte:`${formattedDate} ${hour}:00`,
                        
                        demanda_frio:this.demandaFrio[i+(24*day)],
                    })
                }
            }
            //console.log(hoursList);
       },
       convertirFecha(fechaString) {
          let [fecha,hora]=fechaString.split(' ');
          //Por problemas de leer de csv, a veces la fecha
          let dia;
          let mes;
          let anio;
          if (fecha.includes('/')) {
            // Si la fecha tiene '/' como separador
             [dia, mes, anio] = fecha.split('/');
            } else if (fecha.includes('-')) {
                // Si la fecha tiene '-' como separador
             [anio, mes, dia] = fecha.split('-');
            }
          let [horaStr,minutoStr] = hora.split(':')
          horaStr = horaStr.padStart(2,'0');
          //console.log("Fecha: ", `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`)
          horaStr = horaStr.padStart(2,'0'); //Rellenar los dígitos individuales en 2
          const fechaItem = `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`
          return fechaItem;
        },
          //Llamada a input de CSV
          importFromCSV() {
          this.$refs.fileInput.click();
        },
        parseNumber(value) {
            if (!value) return 0;
            value = value.trim();

            if (value.includes(',') && !value.includes('.')) {
                value = value.replace(/\./g, '');        
                value = value.replace(',', '.');          
            }

            else if (value.includes(',') && value.includes('.')) {
                
                if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
                value = value.replace(/\./g, '');       
                value = value.replace(',', '.');      
                }
                
                else {
                value = value.replace(/,/g, '');        
                }
            }
            return parseFloat(value);
            },
    guess_delimiter(headers) {
      return headers.split(",").length > headers.split(";").length ? "," : ";";
    },

      handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  // Validar extensión
  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon:"error", title:"Formato no válido", text:"Solo se admiten archivos .csv." });
    event.target.value = "";
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data  = e.target.result;
      const delim = (this.guess_delimiter ? this.guess_delimiter(data.split("\n")[0]) : ";") || ";";

      Papa.parse(data, {
        delimiter: delim,
        skipEmptyLines: true,
        header: true,
        complete: (result) => {
          // =====  Filas válidas
          let rows = result.data || [];
          rows = rows.filter(r => Object.values(r).some(v => String(v ?? "").trim() !== ""));
          if (!rows.length) {
            Swal.fire({ icon:"error", title:"CSV vacío", text:"El archivo no contiene datos." });
            event.target.value = "";
            return;
          }

          // =====  Cabeceras detectadas
          let headers = (result.meta && result.meta.fields) ? [...result.meta.fields] : Object.keys(rows[0] || {});
          if (headers[0]) headers[0] = String(headers[0]).replace(/^\uFEFF/, ""); 
          headers = headers.map(h => String(h).trim());

          // =====  Validación de cabeceras 
          const EXPECTED = HEADERS_OFICIALES_FRIO; 
          const faltantes = EXPECTED.filter(h => !headers.includes(h));
          const extras    = headers.filter(h => !EXPECTED.includes(h)).map(x => String(x).trim()).filter(Boolean);
          const desordenadas = [];
          EXPECTED.forEach((h, i) => { if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`); });

          if (faltantes.length || extras.length || desordenadas.length) {
            const seccion = (titulo, arr) =>
              arr.length
                ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
                   <ul style="margin:0 0 8px 18px; padding:0;">${arr.map(x => `<li>${x}</li>`).join("")}</ul>`
                : "";

            const html =
              `<div style="text-align:left;">
                 <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
                 ${seccion("❌ Faltan", faltantes)}
                 ${seccion("⚠️ Sobran", extras)}
                 ${seccion("🔄 Desordenadas", desordenadas)}
               </div>`;

            Swal.fire({ icon:"error", title:"Encabezados incorrectos", html, width: 800 });
            event.target.value = "";
            return;
          }

          // =====  Validación del NÚMERO DE FILAS vs horizonte
         /* const esperadas = Number(this.horizonte_horas) || 0;
          if (esperadas > 0 && rows.length !== esperadas) {
            const diff = rows.length - esperadas;
            const detalle = diff > 0
              ? `Sobran <b>${diff}</b> fila(s).`
              : `Faltan <b>${Math.abs(diff)}</b> fila(s).`;
            Swal.fire({
              icon: "error",
              title: "Número de filas incorrecto",
              html: `Se esperaban <b>${esperadas}</b> filas y se recibieron <b>${rows.length}</b>.<br>${detalle}.`
            });
            event.target.value = "";
            return;
          }*/

          // ===== Huecos por columna (y numérico)
          const COL_H   = "Horizonte";
          const COL_HR  = "Hora";
          const COL_VAL = "Demanda de frío (MW)";

          const faltasPorCol = { [COL_H]: [], [COL_HR]: [], [COL_VAL]: [] };
          const negativos = [];

          rows.forEach((row, idx) => {
            const line   = idx + 2; 
            const h      = String(row[COL_H] ?? "").trim();
            const hora   = String(row[COL_HR] ?? "").trim();
            const valRaw = row[COL_VAL];

            if (!h)    faltasPorCol[COL_H].push(line);
            if (!hora) faltasPorCol[COL_HR].push(line);

            if (valRaw === undefined || valRaw === null || String(valRaw).trim() === "") {
              faltasPorCol[COL_VAL].push(line);
            } else {
              const n = this.parseNumber(String(valRaw));
              if (!Number.isFinite(n)) {
                faltasPorCol[COL_VAL].push(line);
              } else if (n < 0) {
                // BLOQUEAR negativos 
                negativos.push(line);
              }
            }
          });

          const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
          if (columnasConFaltas.length) {
            const html = columnasConFaltas
              .map(([col, arr]) => `• <b>${col}</b>: líneas <b>${arr.slice(0,10).join(", ")}${arr.length>10?"…":""}</b>`)
              .join("<br>");
            Swal.fire({ icon:"error", title:"Faltan datos obligatorios", html });
            event.target.value = "";
            return;
          }

          if (negativos.length) {
            Swal.fire({
              icon: "error",
              title: "Valores negativos no permitidos",
              html: `Se han encontrado valores negativos en <b>${COL_VAL}</b> (líneas: <b>${
                negativos.slice(0, 10).map(n => `L${n}`).join(", ")
              }${negativos.length > 10 ? "…" : ""}</b>).`
            });
            event.target.value = "";
            return;
          }

          // =====  Aplicar importación 
          const nuevos         = [...this.demandaFrio];
          const invalidas      = [];
          const noEncontradas  = [];

          rows.forEach((row, idx) => {
            const horizonteCsv = String(row[COL_H] ?? "").trim();
            const horizonteKey = this.convertirFecha(horizonteCsv);
            const valorCsv     = this.parseNumber(String(row[COL_VAL]));

            if (!horizonteCsv || !Number.isFinite(valorCsv)) {
              invalidas.push(idx + 2);
              return;
            }

            const i = nuevos.findIndex(it => it.horizonte === horizonteKey);
            if (i === -1) {
              noEncontradas.push(horizonteCsv);
            } else {
              nuevos[i] = { ...nuevos[i], valor: valorCsv };
            }
          });

          if (invalidas.length) {
            Swal.fire({
              icon:"error",
              title:"Filas no válidas",
              html:`Hay filas con horizonte vacío o valor no numérico (líneas: <b>${invalidas.slice(0,10).join(", ")}${invalidas.length>10?"…":""}</b>).`,
            });
            event.target.value = "";
            return;
          }

          if (noEncontradas.length) {
            Swal.fire({
              icon:"error",
              title:"Horizontes no encontrados",
              html:`No se encontraron en la senda: <b>${noEncontradas.slice(0,8).join(", ")}${noEncontradas.length>8?"…":""}</b>.`,
            });
            event.target.value = "";
            return;
          }

          
          this.demandaFrio = nuevos;
          this.$emit("update:demanda_frio", [...this.demandaFrio]);
          Swal.fire({ icon:"success", title:"Importación correcta", text:`${rows.length} registros actualizados.` });
          event.target.value = "";
        },
        error: () => {
          Swal.fire({ icon:"error", title:"Error", text:"No se pudo leer el CSV." });
          event.target.value = "";
        }
      });
    } catch (err) {
      Swal.fire({ icon:"error", title:"Error al importar", text: err?.message ?? "Archivo no válido." });
      event.target.value = "";
    }
  };

  reader.readAsText(file, "utf-8");
},



        error(n_error,extra=""){
        switch(n_error){
            case 1:
                this.error_msg="El csv debe contener las cabeceras de 'Horizonte' y 'Demanda de frío (MW)'";
                break;
                case 2:
            this.error_msg="El coeficiente debe ser numérico";
                break;
                case 3:
                this.error_msg="No existe el horizonte: " +extra;
                break;
                case 4:
                   console.log("Caso 4");
                  break;
                case 5:
                  console.log("Caso 5");
                  break;
                case 6:
                  console.log("Caso 6");
                  break;
                case 7:
                  console.log("Caso 7");
                  break;
                case 8:
                  console.log("Caso 8");
                  break;
                case 9:
                  console.log("Caso 9");
                  break;
                case 10:
                  console.log("Caso 10");
                  break;
             
        }
        this.showAlert=true

       },

   },
}

</script>
<style scoped>
.contenedor-tabla {
  max-width: 600px;
  /* margin: auto; */
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
 thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
    padding: 10px;
  }

  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }

  input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #024e74;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
.encabezado_bold {
    font-size:14px;
}


</style>